module.exports = __webpack_public_path__ + "93d903a0c9ebf2afaf5bc60fec797231.pdf";